import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { Result } from '../../../../domain/models/http-response.model';
import { PublicUserModel } from '../../../../domain/models/user-profile.dto';
import { AuthRepository } from '../../../../domain/repositories/auth.repository';

@Injectable({ providedIn: 'root' })
export class GetPublicUserUsecase
  implements Usecase<string, Promise<Result<PublicUserModel, Error>>>
{
  constructor(private authRepository: AuthRepository) {}

  async execute(userId: string): Promise<Result<PublicUserModel, Error>> {
    return this.authRepository.getPublicUserProfile(userId);
  }
}
